import { API_GET_ALL_FEATURE_FLAGS } from 'constants/db.constants';
import API from 'services/api.services';

export const getAllFeatureFlags = async () => {
	const paramsSetting = {};
	let res = await API.getInstance().get(API_GET_ALL_FEATURE_FLAGS, paramsSetting, null, null, true);
	return res?.data;
};
